export default __webpack_public_path__ + "static/media/AtTheFunctionBg.5103ab6c.jpg";